// extracted by mini-css-extract-plugin
module.exports = {"list":"InlineBulletedList_list__aJK6j","listItem":"InlineBulletedList_listItem__1PRml","compact":"InlineBulletedList_compact__2Zg9D"};